import { useState, useEffect } from 'react';

interface DeviceInfo {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isIOS: boolean;
  isIPad: boolean;
  isIPhone: boolean;
  isAndroid: boolean;
}

export const useDeviceDetect = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    isIOS: false,
    isIPad: false,
    isIPhone: false,
    isAndroid: false,
  });

  useEffect(() => {
    const handleDeviceDetection = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const platform = navigator.platform.toLowerCase();
      const width = window.innerWidth;
      
      // Check for iOS devices
      const isIOS = /iphone|ipad|ipod/.test(userAgent) || 
                    (platform === 'macintel' && navigator.maxTouchPoints > 1); // iPad Pro detection
      
      // Specific device checks
      const isIPad = /ipad/.test(userAgent) || 
                     (platform === 'macintel' && navigator.maxTouchPoints > 1); // iPad Pro detection
      const isIPhone = /iphone/.test(userAgent);
      const isAndroid = /android/.test(userAgent);
      
      // Check for tablets (including Android tablets and viewport-based detection)
      const isTablet = isIPad || 
                       (isAndroid && !/mobile/.test(userAgent)) ||
                       /tablet/.test(userAgent) ||
                       (width >= 768 && width <= 1024); // iPad dimensions
      
      // Check for mobile devices
      const isMobile = isIPhone || 
                       (isAndroid && /mobile/.test(userAgent)) ||
                       /mobile|phone/.test(userAgent) ||
                       (width < 768); // Mobile width
      
      // Desktop is when it's neither mobile nor tablet
      const isDesktop = !isMobile && !isTablet;
      
      setDeviceInfo({
        isMobile,
        isTablet,
        isDesktop,
        isIOS,
        isIPad,
        isIPhone,
        isAndroid,
      });
    };

    handleDeviceDetection();
    
    // Re-detect on window resize (for development/testing)
    window.addEventListener('resize', handleDeviceDetection);
    
    return () => {
      window.removeEventListener('resize', handleDeviceDetection);
    };
  }, []);

  return deviceInfo;
};